import { colors, FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  title: FelaCSS;
  iconWrap: FelaCSS;
  description: FelaCSS;
  arrow: FelaCSS;
  wrapper: FelaCSS;
  contentWrapper: FelaCSS;
  backgroundSwirl: FelaCSS;
}

export type Theme = 'primary' | 'success' | 'alert' | 'error';

const getThemeColor = (theme?: Theme): { border: string; background: string } => {
  const primary = {
    border: colors.indigoCrush,
    background: colors.indigoCrush04,
  };

  switch (theme) {
    case 'success':
      return {
        border: colors.teal120,
        background: colors.teal20,
      };
    case 'alert':
      return {
        border: colors.peachRose120,
        background: colors.peachRose20,
      };
    case 'error':
      return {
        border: colors.blushTangerine120,
        background: colors.pinkJoy,
      };
    case 'primary':
    default:
      return primary;
  }
};

interface IStyleProps {
  size: 'small' | 'default' | 'large';
  theme?: Theme;
  isClickable?: boolean;
  hasIcon: boolean;
}

const styles = ({ size, theme, isClickable, hasIcon }: IStyleProps): IStyles => {
  const themeColor = getThemeColor(theme);

  return {
    wrapper: {
      position: 'relative',
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      padding: size === 'small' ? 3 : 4,
      backgroundColor: themeColor.background,
      border: `1px solid ${themeColor.border}`,
      borderRadius: 8,
      overflow: 'hidden',
      ...(isClickable && { cursor: 'pointer' }),
    },

    contentWrapper: {
      flexGrow: 1,
      gap: size === 'small' ? 2 : 4,
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      columnGap: hasIcon ? spacing[2] : 0,
    },

    title: {
      flexDirection: 'row',
      alignItems: 'center',
      fontDefaultSemiBold: size === 'small' ? 12 : size === 'default' ? 15 : 18,
      gridRow: 1,
      gridColumn: 2,
      columnGap: 20,
    },

    iconWrap: {
      gridRow: 1,
      gridColumn: 1,
      justifyContent: 'center',
    },

    description: {
      fontDefault: size === 'small' ? 12 : 14,
      whiteSpace: 'pre-line',
      gridRow: 2,
      gridColumn: 2,
    },

    arrow: {
      transform: 'rotate(-90deg)',
    },
    backgroundSwirl: {
      position: 'absolute',
      left: 0,
      top: 0,
      zIndex: 0,
    },
  };
};

export default styles;
